import { createRouter, createWebHashHistory} from "vue-router";
import LoginVue from "../View/Login.vue"
import LayOut from "../View/LayOut.vue";
import Home from "../View/Home.vue"
import PrivacyAgreement from "../View/PrivacyAgreement.vue";
import TechHelp from "../View/techHelp.vue";
const routes = [
  {
    path: "/Index",
    name: "Index",
    component:LayOut
  },
  {
    path:"/Login",
    name:"Login",
    component:LoginVue
  },
  {
    path:"/",
    name:"Home",
    component:Home
  } ,{
    path:"/PrivacyPolicy",
    name:"Agreement",
    component:PrivacyAgreement
  },
  {
    path:"/UserAgreement",
    name:"helper",
    component:TechHelp
  },
];
 
const router = createRouter({
  history: createWebHashHistory(""),
  routes
});
 
export default router;